export default __webpack_public_path__ + "static/media/composition_24px.4c053da9.svg";